module.exports = __webpack_public_path__ + "img/fdccd49.png";